import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { routes } from 'utils/common/routes';

const Page404 = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full h-full flex items-center justify-center">
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button type="primary" onClick={() => navigate(routes.home)}>
            Back Home
          </Button>
        }
      />
    </div>
  );
};

export default Page404;
